import type { ZodType } from "zod"
import { isAddress } from "viem"
import { z } from "zod"

function createSuccessfulResponse<TData extends ZodType>(data: TData) {
  return z.object({
    success: z.literal(true),
    data: data,
  })
}

function createErrorResponse() {
  return z.object({
    success: z.literal(false),
    message: z.string().optional(),
  })
}

/**
 * This can't be used with safely-fetch since it abstracts the basic logic
 */
export function createApiResponse<TData extends ZodType>(data: TData) {
  return z.intersection(createErrorResponse(), createSuccessfulResponse(data))
}

export const ethereumAddress = z.string().refine((v) => isAddress(v))
